import React from 'react';

export default function TravelerMailerSvg({ width = 30, height = 30 }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 30 30" fill="none">
            <g clip-path="url(#clip0_2281_100253)">
                <path d="M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z" fill="#A887AF" />
                <path d="M24.364 8.64062H5.59908L12.3971 15.7191L14.3588 17.7054C13.2914 17.4614 13.2254 17.3094 12.7524 16.9233C12.5044 16.7207 12.0251 16.1702 11.2971 15.4268C9.02477 13.1064 5.16895 9.16902 5.16895 9.16902V20.8187L5.65322 21.303L5.59902 21.3595L14.2195 29.9799C14.478 29.9932 14.7382 30 15 30C23.2843 30 30 23.2843 30 15C30 14.7512 29.9935 14.504 29.9816 14.2582L24.364 8.64062Z" fill="#896F8E" />
                <path d="M5.16895 9.16895V20.8187L10.8501 14.9703L5.16895 9.16895Z" fill="white" />
                <path d="M24.8306 9.16895V20.8187L19.1777 14.9938L24.8306 9.16895Z" fill="white" />
                <path d="M5.59863 8.64062H24.3636L16.9887 16.3198C16.4638 16.8663 15.7388 17.1752 14.9811 17.1752C14.2235 17.1752 13.4985 16.8663 12.9736 16.3198L5.59863 8.64062Z" fill="white" />
                <path d="M17.4141 16.7283C16.7814 17.3871 15.8946 17.765 14.9811 17.765C14.0677 17.765 13.1809 17.3872 12.5482 16.7283L11.2973 15.4258L5.59863 21.3594H24.3636L18.665 15.4258L17.4141 16.7283Z" fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_2281_100253">
                    <rect width="30" height="30" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}